import { render } from "./attendances.vue?vue&type=template&id=897081e4&scoped=true"
import script from "./attendances.vue?vue&type=script&lang=js"
export * from "./attendances.vue?vue&type=script&lang=js"

import "./attendances.vue?vue&type=style&index=0&id=897081e4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-897081e4"]])

export default __exports__